import { BaseWorkflowTaskState, WorkflowTaskPermissions, WorkflowTaskResponse, WriteWorkflowTaskModel } from "../../api/clients/workflowTasks/DTOs";
import WorkflowTasksClient from "../../api/clients/workflowTasks/WorkflowTasksClient";
import { retrieveUserDatabase } from "./indexedDb";
	
export function getWorkflowTask<TState extends BaseWorkflowTaskState>(
	workflowTaskId: number,
): Promise<WorkflowTaskResponse<TState> | undefined>;
export function getWorkflowTask<TState extends BaseWorkflowTaskState>(
	workflowTaskId: number,
	permission: WorkflowTaskPermissions.Read
): Promise<WorkflowTaskResponse<TState> | undefined>;
export function getWorkflowTask<TState extends BaseWorkflowTaskState>(
	workflowTaskId: number,
	permission: WorkflowTaskPermissions.Write
): Promise<WriteWorkflowTaskModel<TState> | undefined>;
export async function getWorkflowTask<TState extends BaseWorkflowTaskState>(
	workflowTaskId: number,
	permission?: WorkflowTaskPermissions,
): Promise<WorkflowTaskResponse<TState> | undefined> {

	// TODO - make this thing target the stored cache

	const database = await retrieveUserDatabase();

	if (navigator.onLine) {
		const workflowTaskClient = new WorkflowTasksClient();

		const {data: response} = await workflowTaskClient.getWorkflowTask(workflowTaskId, permission)

		const transaction = database.transaction('workflowTaskCache', 'readwrite')
		const workflowTaskCache = transaction.objectStore('workflowTaskCache')
		
		workflowTaskCache.put(response, response.id.toString())
		transaction.commit()
		await transaction.done

		return response as WorkflowTaskResponse<TState>
	} else {
		const transaction = database.transaction('workflowTaskCache', 'readonly')
		const workflowTaskCache = transaction.objectStore('workflowTaskCache')

		const result = await workflowTaskCache.get(workflowTaskId.toString())
		return result as WorkflowTaskResponse<TState>
	}	
}

export async function setWorkflowTask<TState extends BaseWorkflowTaskState>(workflowTask: WorkflowTaskResponse<TState>) {
	const database = await retrieveUserDatabase();

	const transaction = database.transaction('workflowTaskCache', 'readwrite')
	const workflowTaskCache = transaction.objectStore('workflowTaskCache')

	workflowTaskCache.put(workflowTask, workflowTask.id.toString())
	// transaction.commit()
	await transaction.done

}

export const removeWorkflowTask = async (workflowTaskId: string) => {
	const database = await retrieveUserDatabase();

	const transaction = database.transaction('workflowTaskCache', 'readwrite')
	const workflowTaskCache = transaction.objectStore('workflowTaskCache')
	
	await workflowTaskCache.delete(workflowTaskId)
	transaction.commit()

	await transaction.done
}